module.exports = __webpack_public_path__ + "static/img/itmo-white.00c3d14.png";